// extracted by mini-css-extract-plugin
module.exports = {"Steps":"Steps_Steps__10KC3","text":"Steps_text__Cs8cg","textLink":"Steps_textLink__2hwAd","modalMenu":"Steps_modalMenu__2LGpK"};